import { useQuery } from 'react-query';
import { ContentHttpService, Theme } from '../services';

interface UseThemesProps {
  page?: number;
  pageSize?: number;
  featured?: boolean;
}

export const useThemes = ({ page = 1, pageSize = 100, featured }: UseThemesProps = {}) => {
  const { data: themes = [], isLoading: loading, error, refetch } = useQuery<Theme[]>(
    ['themes', page, pageSize, featured],
    async () => {
      const response = await ContentHttpService.getThemes(featured);
      return response as Theme[];
    },
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    }
  );

  return { themes, loading, error, refetch };
}; 